export default __webpack_public_path__ + "static/media/Conflict-of-Interest-Management-Policy-Nov-2020.4a557f86.pdf";